<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex
        v-for="(user, i) in users"
        :key="i"
        pa-2
      >
        <user-card :user="user"></user-card>
      </v-flex>
    </v-layout>
    <v-btn
      @click="goToAdd"
      bottom
      fab
      fixed
      right
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import UserCard from '../components/UserCard.vue';

export default {
  name: 'UsersView',
  components: { UserCard },
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
  },
  methods: {
    goToAdd() {
      this.$router.push({ name: 'Add User' });
    },
  },
};

</script>
